import { render, staticRenderFns } from "./editOrg.vue?vue&type=template&id=02bf349d"
import script from "./editOrg.vue?vue&type=script&lang=js"
export * from "./editOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports